/**
 * Stable per-device/replica origin id (decision #20: conflict attribution).
 * Persisted in localStorage so the same browser keeps the same origin across
 * sessions. Safe to read here — this is the web platform layer, not core.
 */
const ORIGIN_KEY = "roqeet.device.origin";

export function getDeviceOrigin(): string {
  try {
    let origin = localStorage.getItem(ORIGIN_KEY);
    if (!origin) {
      origin = Math.random().toString(36).slice(2, 10);
      localStorage.setItem(ORIGIN_KEY, origin);
    }
    return origin;
  } catch {
    // Private mode / storage disabled: fall back to an ephemeral origin.
    return "ephemeral";
  }
}
